// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2944ca73","455":"1037e086","977":"ff597c14"}[chunkId] + ".chunk.js";
};